export const pink = "#FFB0B7";
export const orange = "#FFA500";
export const green = "#70B6C1";
const yellow = "#F3CC5C";
const gray = "#E6E9ED";

export const waitingColor = pink;
export const shippingColor = orange;
export const deliveryColor = green;
